import { useActiveReferenceBarID } from '../../../controller/hooks/useActiveReferenceBarID.ts';
import { useMetadataByID } from '../../../controller/hooks/useMetadataByID.ts';
import { addressAndListingIDFromReferenceViewID } from '../utils/addressAndListingIDFromReferenceViewID.ts';

export function useParsedActiveID() {
  const activeID = useActiveReferenceBarID();
  const metadataByID = useMetadataByID();

  return addressAndListingIDFromReferenceViewID(activeID, metadataByID);
}
